import { classes, DOM, matchMedia, breakpoints } from '../const';

// import { initShareBtn } from './_shareBtns';
// import { initDropdown } from './_dropdowns';
// import { initPaginationBlock } from './_paginationBlocks';

const { isActive, noOverflow } = classes
const { $hbody, $document } = DOM;

let $$jobsMenuBtns = $('.js-jobs-link');
let $jobsSearch = $('.js-jobs-search');
let $$jobsCloseBtns = $('.js-jobs-close');
let $$searchTabs = $('.js-search-tabs');
let $$searchTabLinks = $$searchTabs.find('.js-search-tablink');

let $mobFilterBtn = $jobsSearch.find('.js-jobs-mob-filters-btn');
let $mobFilterCloseBtn = $jobsSearch.find('.js-jobs-filters-close');
let $filters = $jobsSearch.find('.js-jobs-filters');
let $jobsSearchForm = $jobsSearch.find('.js-jobs-search-form');
let $jobsSearchInput = $jobsSearchForm.find('.js-jobs-search-input');
let $resetBtn = $jobsSearch.find('.js-jobs-search-reset');
let $$accFilters = $jobsSearchForm.find('.js-acc-filter input[type="checkbox"]');
// let $resultsPanel = $jobsSearchForm.find('.js-jobs-search-result-panel');
// let $preloader = $jobsSearch.find('.backup__js-jobs-search-loader');

const initializeJobsSearch = () => {
   $$jobsMenuBtns = $('.js-jobs-link');
   $jobsSearch = $('.js-jobs-search');
   $$jobsCloseBtns = $('.js-jobs-close');
   $$searchTabs = $('.js-search-tabs');
   $$searchTabLinks = $$searchTabs.find('.js-search-tablink');

   $mobFilterBtn = $jobsSearch.find('.js-jobs-mob-filters-btn');
   $mobFilterCloseBtn = $jobsSearch.find('.js-jobs-filters-close');
   $filters = $jobsSearch.find('.js-jobs-filters');
   $jobsSearchForm = $jobsSearch.find('.js-jobs-search-form');
   $jobsSearchInput = $jobsSearchForm.find('.js-jobs-search-input');
   $resetBtn = $jobsSearch.find('.js-jobs-search-reset');
   $$accFilters = $jobsSearchForm.find('.js-acc-filter input[type="checkbox"]');
   // $resultsPanel = $jobsSearchForm.find('.js-jobs-search-result-panel');
   // $preloader = $jobsSearch.find('.backup__js-jobs-search-loader');
};

initializeJobsSearch();

const openJobsSearch = () => {
  $hbody.addClass(noOverflow);
  $jobsSearch.addClass(isActive);
};

const closeJobsSearch = () => {
  $hbody.removeClass(noOverflow);
  $jobsSearch.removeClass(isActive);
};

const resetForm = (settings) => {
  initializeJobsSearch();
  $jobsSearchForm[0].reset();
  $$accFilters.prop('checked', false).trigger('change', settings);
  // $jobsSearchForm.submit();
};

// const initResultsList = () => {
  // initializeJobsSearch();
  // const $$shareBtns = $resultsPanel.find('.js-share-btn');
  // const $$dropdowns = $resultsPanel.find('.js-dropdown');
  // const $$paginationBlocks =  $resultsPanel.find('.js-pagination-block');
  //
  // $$shareBtns.each((i, el) => {
  //   initShareBtn(el);
  // });
  //
  // $$dropdowns.each((i, el) => {
  //   initDropdown($(el));
  // });
  //
  // $$paginationBlocks.each((i, el) => {
  //   initPaginationBlock($(el));
  // });



  // $$searchTabs.find('.js-dropdown-select select').on('change', () => {
  //   $jobsSearchForm.submit();
  // });
// };



const jobsSearch = () => {
  initializeJobsSearch();
  // $jobsSearchForm.submit(event => {
  //   // event.preventDefault();
  //   // const method = $jobsSearchForm.attr('method');
  //   // const url = $jobsSearchForm.attr('action');
  //
  //   // $preloader.addClass(isActive);
  //
  //   // $.ajax({
  //   //   method,
  //   //   url,
  //   //   cache: false,
  //   //   data: $jobsSearchForm.serialize()
  //   // })
  //   // .done(html => {
  //   //   $resultsPanel.empty();
  //   //
  //   //   $resultsPanel.append(html);
  //   //
  //   //   initResultsList();
  //   //
  //   //   setTimeout(() => {
  //   //     $preloader.removeClass(isActive);
  //   //   }, 300);
  //   // })
  //   // .fail(() => {
  //   //   setTimeout(() => {
  //   //     $preloader.removeClass(isActive);
  //   //   }, 300);
  //   //
  //   // });
  //
  // });

  // $$searchTabs.find('.js-dropdown-select select').on('change', () => {
  //   $jobsSearchForm.submit();
  // });
  //
  // $filters.find('.js-acc-filter input[type="checkbox"]').change(() => {
  //   $jobsSearchForm.submit();
  // });

  $resetBtn.click(event => {
    event.preventDefault();
    resetForm();
  });

  $$jobsMenuBtns.click(event => {
    event.preventDefault();
    const $target = $(event.target);

    if ($target.closest('.js-footer-search').length) {
      const $input = $target.closest('.js-footer-search').find('input[type=search]');
      $jobsSearchInput.val($input.val());
      $input.val('');
      // $jobsSearchForm.submit();
    }
    openJobsSearch();
  });

  $$jobsCloseBtns.click(event => {
    event.preventDefault();
    closeJobsSearch();
  });

  $$searchTabLinks.each((i, el) => {
  //   const tabId = $(el).data('tab');
  //
  //
  //
    $(el).click(event => {
      event.preventDefault();
      const settings = {
        doNotMakeAjaxCall: true
      };
      resetForm(settings);
  //
  //     const $$searchTabContents = $$searchTabs.find('.js-search-tabcontent');
  //
  //
  //     $$searchTabLinks.each((j, tabLink) => {
  //       if (tabLink === el) {
  //         $(el).addClass(isActive);
  //       } else {
  //         $(tabLink).removeClass(isActive);
  //       }
  //     });
  //
  //     $$searchTabContents.each((j, tabContent) => {
  //       if ($(tabContent).data('tab') === tabId) {
  //         $(tabContent).addClass(isActive);
  //       } else {
  //         $(tabContent).removeClass(isActive);
  //       }
  //     });
  //
    });
  });



  $mobFilterBtn.click(event => {
    event.preventDefault();
    $filters.addClass(isActive);
  });

  $mobFilterCloseBtn.click(event => {
    event.preventDefault();
    // $jobsSearchForm.submit();
    $filters.removeClass(isActive);
  });

  $filters.click(event => {
    if (!$(event.target).closest('.js-jobs-filters-inner').length) {
      $filters.removeClass(isActive);
      if (!matchMedia(breakpoints.sm)) {
        // $jobsSearchForm.submit();
      }
    }
  });

  $document.keydown(event => {
    if (event.which === 27 && $jobsSearch.hasClass(isActive)) {
      closeJobsSearch();
    }
  });


};

export default jobsSearch;
